import { setDefaults } from './config.defaults';
import type { IAppConfig } from './config.interface';

/* eslint-disable-next-line @typescript-eslint/no-var-requires */
const config: IAppConfig = require('./config.js');

const configWithDefaults = setDefaults(config);

export { configWithDefaults as config };
